import React from 'react';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import { LinkContainer } from './styles';

function NavbarLink({
  children,
  to,
  callToAction,
  hasSubMenu,
  isActive,
  label,
}) {
  const { push } = useHistory();

  const handleItemClick = to => {
    push(to);
  };

  return (
    <LinkContainer
      callToAction={callToAction}
      hasSubMenu={hasSubMenu}
      isActive={isActive}
    >
      <span onClick={() => handleItemClick(to)}>{children}</span>
      {label && (
        <Link>
          <div className="label">{label > 99 ? '99+' : label}</div>
        </Link>
      )}
    </LinkContainer>
  );
}

export default NavbarLink;
